<template lang="pug">

  ul.filter-bar
    li
      dl.dropdown-menu
        dt(@click="showStatus = !showStatus") Assessment
        transition(name="slide-fade")
          dd(v-if="showStatus" v-on-click-outside="closeStatus")
            .checkbox-group
              input(type="checkbox" name="chkNormalSeverity" id="chkNormalSeverity" value="NORMAL" v-model="filters.severities")
              label(for="chkNormalSeverity") Normal Assessment Score
            .checkbox-group
              input(type="checkbox" name="chkMildSeverity" id="chkMildSeverity" value="MILD" v-model="filters.severities")
              label(for="chkMildSeverity") Mild Assessment Score
            .checkbox-group
              input(type="checkbox" name="chkModerateSeverity" id="chkModerateSeverity" value="MODERATE" v-model="filters.severities")
              label(for="chkModerateSeverity") Moderate Assessment Score
            .checkbox-group
              input(type="checkbox" name="chkSevereSeverity" id="chkSevereSeverity" value="SEVERE" v-model="filters.severities")
              label(for="chkSevereSeverity") Severe Assessment Score
            hr
            .radio-group
              input(type="radio" name="scoreFilter" id="scoreImproving" value="improving" v-model="filters.assessmentTrend")
              label(for="scoreImproving") Improving Functioning
            .radio-group
              input(type="radio" name="scoreFilter" id="scoreDeclining" value="declining" v-model="filters.assessmentTrend")
              label(for="scoreDeclining") Declining Functioning

            //- .radio-group
            //-   input(type="radio" name="moodFilter" id="moodImproving" value="improving" v-model="filters.moodTrend")
            //-   label(for="moodImproving") Improving Mood
            //- .radio-group
            //-   input(type="radio" name="moodFilter" id="moodDeclining" value="declining" v-model="filters.moodTrend")
            //-   label(for="moodDeclining") Declining Mood

    li
      dl.dropdown-menu
        dt(@click="showFocus = !showFocus") Focus
        transition(name="slide-fade")
          dd(v-if="showFocus" v-on-click-outside="closeFocus")
            .checkbox-group(v-for="item in wellnessPrograms" :key="item.id")
              input(type="checkbox" :name="'focus' + item.id" :id="'focus' + item.id" :value="item.shortName" v-model="filters.focuses")
              label(:for="'focus' + item.id") {{ item.label }}
    li
      dl.dropdown-menu
        dt(@click="showAccessCode = !showAccessCode") Access Code
        transition(name="slide-fade")
          dd(v-if="showAccessCode" v-on-click-outside="closeAccessCode")
            .dropdown-filter
              input(type="text" placeholder="Search access codes" v-model="txtAccessCode")
            .checkbox-group(v-for="(ac, index) in filteredAccessCodes")
              input(type="checkbox" :name="'ac' + index" :id="'ac' + index" :value="ac" v-model="filters.accessCodes")
              label(:for="'ac' + index") {{ ac }}
    li
      dl.dropdown-menu
        dt(@click="showReferrer = !showReferrer") Referrer
        transition(name="slide-fade")
          dd(v-if="showReferrer" v-on-click-outside="closeReferrer")
            .dropdown-filter
              input(type="text" placeholder="Search referrers" v-model="txtReferrer")
            .checkbox-group(v-for="(ref, index) in filteredReferrers" :key="'ref' + index")
              input(type="checkbox" :name="'ref' + index" :id="'ref' + index" :value="ref" v-model="filters.referrers")
              label(:for="'ref' + index") {{ ref }}
    li
      dl.dropdown-menu
        dt(@click="showLoginHistory = !showLoginHistory") Interaction
        transition(name="slide-fade")
          dd(v-if="showLoginHistory" v-on-click-outside="closeInteraction")
            .radio-group
              input(type="radio" name="intFilter" id="30day" value="30" v-model.number="filters.lastInteractionDays")
              label(for="30day") Last 30 Days
            .radio-group
              input(type="radio" name="intFilter" id="60day" value="60" v-model.number="filters.lastInteractionDays")
              label(for="60day") Last 60 Days
            .radio-group
              input(type="radio" name="intFilter" id="90day" value="90" v-model.number="filters.lastInteractionDays")
              label(for="90day") Last 90 Days
            .radio-group
              input(type="radio" name="intFilter" id="180day" value="180" v-model.number="filters.lastInteractionDays")
              label(for="180day") Last 180 Days
            .radio-group
              input(type="radio" name="intFilter" id="360day" value="360" v-model.number="filters.lastInteractionDays")
              label(for="360day") Last 360 Days


    li
      dl.dropdown-menu
        dt(@click="showReview = !showReview") Review
        transition(name="slide-fade")
          dd(v-if="showReview" v-on-click-outside="closeReview")
            .radio-group
              input(type="radio" name="reviewFilter" id="noReview" value="notReviewed" v-model="filters.reviewType")
              label(for="noReview") Not Reviewed
            hr
            .radio-group
              input(type="radio" name="reviewFilter" id="reviewRange" value="reviewedWithin" v-model="filters.reviewType")
              label(for="reviewRange") No Review within:
              .review-range-days
                input(type="number" min="1" max="720" v-model.number="filters.lastReviewedDays" id="customReviewRange" :disabled="filters.reviewType !== 'reviewedWithin'" v-on:keyup="enforceDayRange")
                span Days
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import _ from 'lodash';
import { mixin as onClickOutside } from 'vue-on-click-outside';

export default {
  name: 'PatientFilter',
  props: {
    patientFilters: {
      type: Object,
      required: true
    },
    applyFilters: {
      type: Function,
      required: true
    },
    filtersChanged: {
      type: Boolean
    }
  },
  data() {
    return {
      showStatus: false,
      showFocus: false,
      showAccessCode: false,
      showReferrer: false,
      showLoginHistory: false,
      showReview: false,
      filters: {},
      txtAccessCode: '',
      txtReferrer: ''
    };
  },
  computed: {
    filteredAccessCodes: function() {
      if (_.isEmpty(this.accessCodes)) {
        return [];
      }
      if (_.isEmpty(this.txtAccessCode)) {
        return this.accessCodes;
      }
      const filtered = this.accessCodes.filter(ac => ac.toUpperCase().indexOf(this.txtAccessCode.toUpperCase()) !== -1);
      let codes = [];
      this.filters.accessCodes.forEach((ac) => {
        // checked codes should exist within filtered results
        let idx = _.findIndex(filtered, function(item) { return item === ac; });
        if (idx !== -1) {
          codes.push(ac);
        }
      });

      if (!_.isEqual(this.filters.accessCodes, codes)) {
        this.filters.accessCodes = codes;
      }

      return filtered;
    },
    filteredReferrers: function() {
      if (_.isEmpty(this.referrers)) {
        return [];
      }
      if (_.isEmpty(this.txtReferrer)) {
        return this.referrers;
      }
      let filtered = this.referrers.filter(r => r.toUpperCase().indexOf(this.txtReferrer.toUpperCase()) !== -1);
      let referrers = [];
      this.filters.referrers.forEach((r) => {
        let idx = _.findIndex(filtered, function(item) { return item === r; });
        if (idx !== -1) {
          referrers.push(r);
        }
      });

      if (!_.isEqual(this.filters.referrers, referrers)) {
        this.filters.referrers = referrers;
      }

      return filtered;
    },
    ...mapGetters([
      'wellnessPrograms',
      'accessCodes',
      'referrers'
    ])
  },
  methods: {
    initFilters() {
      this.filters = Object.assign({}, this.patientFilters);
    },
    enforceDayRange() {
      if (this.filters.lastReviewedDays < 1) {
        this.filters.lastReviewedDays = 1;
      } else if (this.filters.lastReviewedDays > 720) {
        this.filters.lastReviewedDays = 720;
      }
    },
    // there wasn't a way to specify a function with parm for onClickOutside mixin, so close method must exist for each dropdown
    closeStatus() {
      this.showStatus = false;
    },
    closeFocus() {
      this.showFocus = false;
    },
    closeAccessCode() {
      this.showAccessCode = false;
    },
    closeReferrer() {
      this.showReferrer = false;
    },
    closeInteraction() {
      this.showLoginHistory = false;
    },
    closeReview() {
      this.showReview = false;
    },
    ...mapActions([
      'loadWellnessPrograms',
      'loadAccessCodes',
      'loadReferrers'
    ])
  },
  created() {
    this.initFilters();
    this.loadWellnessPrograms();
    this.loadAccessCodes();
    this.loadReferrers();
  },
  watch: {
    filtersChanged: function(changed) {
      // refresh filters if they've been changed outside this component
      if (changed) {
        this.initFilters();
      }
    }
  },
  mounted() {
    // notify parent as soon as filters change
    this.$watch('filters', (newVal) => {
      this.applyFilters(newVal);
    }, { deep: true });
  },
  mixins: [ onClickOutside ]
};
</script>

<style lang="scss" scoped>

  .filter-bar {
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: space-apart;
    align-items: stretch;
    li {
      flex: 0 1 20%;
      min-width: 6.25em;
    }
  }
  .dropdown-menu {
    @include zero;
    position: relative;
    dt {
      position: relative;
      margin: 0 auto;
      padding: $xs-spacing $small-spacing;
      background: #fff;
      border: 1px solid $md-grey-200;
      display: block;
      cursor: pointer;
      &:hover, &:focus {
        color: $action-color;
      }
    }
    dt::after {
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 7px solid $base-font-color;
      margin-top: -3px;
      @include position(absolute, 50% $xs-spacing null null);
    }
    dd {
      @include position(absolute, null 0 null 0);
      z-index: 100;
      @include zero;
      padding: $xs-spacing $small-spacing;
      background: #fff;
      border: 1px solid $md-grey-200;
      border-top: 0;
      @include drop-shadow;
      max-height: 60vh;
      overflow-y: auto;
      hr {
        margin: 0 auto $small-spacing;
      }
    }
    .dropdown-filter {
      margin: $xs-spacing auto $small-spacing;
      input {
        font-size: $ms-down1;
      }
    }
    .checkbox-group label,
    .radio-group label {
      font-size: $ms-down1;
    }
    .review-range-days {
      margin: 0.5em auto 0;
      width: 100%;
      display: flex;
      align-items: center;
      input {
        max-width: 3.5em;
        margin-right: 0.5em;
        margin-bottom: 0;
        padding: 0.25em 0.5em;
      }
    }
  }

  // TRANSITIONS
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translatey(-25%);
    opacity: 0;
  }
</style>
